interface SpinnerProps {
  label?: string;
  size?: "sm" | "md" | "lg";
}

const SIZE_MAP: Record<NonNullable<SpinnerProps["size"]>, number> = {
  sm: 16,
  md: 24,
  lg: 40,
};

export function Spinner({ label = "Loading", size = "md" }: SpinnerProps) {
  const px = SIZE_MAP[size];
  return (
    <span role="status" aria-live="polite" className="spinner" style={{ display: "inline-flex", alignItems: "center", gap: "0.5rem" }}>
      <svg
        width={px}
        height={px}
        viewBox="0 0 24 24"
        fill="none"
        className="spinner-svg"
        aria-hidden="true"
      >
        <circle
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="3"
          opacity="0.2"
        />
        <path
          d="M12 2a10 10 0 0 1 10 10"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>
      <span className="sr-only">{label}</span>
    </span>
  );
}
